import { render, staticRenderFns } from "./BuscarProcedimento.vue?vue&type=template&id=6d244869&"
import script from "./BuscarProcedimento.vue?vue&type=script&lang=js&"
export * from "./BuscarProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports